// InvoiceSummaryCards.jsx
import React from "react";
import {
    Box,
    Card,
    CardContent,
    Grid,
    IconButton,
    Typography,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const InvoiceMetricCard = ({ label, value }) => (
    <Card
        elevation={0}
        sx={{
            borderRadius: 4,                 // big rounded corners
            border: "1px solid #e5e7eb",     // light gray border
            boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
            width: '100%'
        }}
    >
        <CardContent
            sx={{
                px: 2,
                py: 2,
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
            }}
        >
            <Box>
                <Typography
                    variant="subtitle2"
                    sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 600,
                        fontSize: '14px',
                        letterSpacing: "0px",
                        color: '#7D7F81'
                    }}
                >
                    {label}
                </Typography>

                <Typography
                    variant="h5"
                    sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 600,
                        fontSize: '24px',
                        letterSpacing: "0px",
                        color: '#111216'
                    }}
                >
                    {value}
                </Typography>
            </Box>

            <IconButton size="small">
                <MoreHorizIcon sx={{ color: "#9ca3af" }} fontSize="small" />
            </IconButton>
        </CardContent>
    </Card>
);

const InvoicingStatisticsKpi = () => {
    const items = [
        { label: "Total Invoices Received", value: "135" },
        { label: "Total Invoices Amount", value: "₹ 235 Cr" },
        { label: "Total Invoices Paid", value: "₹ 95 Cr" },
         { label: "Average Days To Pay ( DTP)", value: "50 Days" },
    ];

    return (
        // <Box sx={{ px: 2, py: 1}}>
        <Grid container spacing={2}>
            {items.map((item) => (
                <Grid size={{ md: 2.4 }} key={item.label}>
                    <InvoiceMetricCard {...item} />
                </Grid>
            ))}
        </Grid>
        // </Box>
    );
};

export default InvoicingStatisticsKpi;
